<template>
	<div>
		<layout-5 :id=pageid :term="term" :is_document="false" :path="'pictures/pic_'" :empty="'No Pictures'" style="height:calc(100vh - 95px);"></layout-5>
		<div class="nav-bar">
			<button v-on:click="addPicture()">Add Picture</button>
			<button v-on:click="deletePicture()">Delete Picture</button>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.PICTURES_PAGE,
		}
	},
	methods:{
		addPicture(){
			router.push('/0404?q='+this.term);
		},
		deletePicture(){
			router.push('/0506?q='+this.term);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Job_Orders_Pictures.vue